import React from 'react';
import picD from '../../assets/pic.webp';
import picT from '../../assets/pic-t.webp';
import picM from '../../assets/pic-m.webp';
import { trackButtonClick } from '../../utils/analytics';

const Hero = () => {
  return (
    <section id='top'>
      <div className='container tc'>
        <div className='s-40 sm-60'></div>
        <h1 className='title-intro'>
          IT-Umschulung &amp; Weiterbildung mit voller deutscher Staatsförderung
        </h1>
        <div className='s-24'></div>
        <h3 className='title-intro-sub w-60 ma'>
          Umschulung zum Fachinformatiker, Cyber Security Weiterbildung oder IT-Quereinsteiger-Kurs—<br />
          100% finanziert von der Agentur für Arbeit. Flexibel online, jobbereit in 12 Monaten.
        </h3>
        <div className='s-32'></div>
        <a
          href='#cta'
          className='button'
          onClick={() => trackButtonClick('Zur IT-Weiterbildung', 'hero')}
        >
          Zur IT-Weiterbildung
        </a>
        <div className='s-32'></div>
        <p className='title-mini'>
          Bildungsgutschein • Aufstiegs-BAföG • Qualifizierungschancengesetz • ESF Plus Förderung verfügbar
        </p>
        <div className='s-48'></div>
        <img
          src={picD}
          alt='Kurse'
          width={1118}
          height={600}
          className='show-d'
        />
        <img
          src={picT}
          alt='Kurse'
          width={940}
          height={504}
          className='show-t'
        />
        <img
          src={picM}
          alt='Kurse'
          width={572}
          height={307}
          className='show-m'
        />
        <div className='s-48'></div>
      </div>
      <div className='back'></div>
    </section>
  );
};

export { Hero };